import { Grid } from '@mui/material';
import { Button } from 'flowbite-react';
import React, { useState } from 'react';
// import DateRangePicker from 'views/Rfqs/DateRangePicker';

const LeadsFilters = ({ leads }) => {
    const [openLeadsFilters, setOpenLeadsFilters] = useState(false);
    const [opentypeOfRfq, setOpentypeOfRfq] = useState(false);
    const [openStatus, setOpenStatus] = useState(false);
    const [openDateRange, setOpenDateRange] = useState(false);
    const [selectedFilters, setSelectedFilters] = useState([]);
    const [newLeadsFixedData, setNewLeadsFixedData] = useState(leads);
    const [newLeads, setNewLeads] = useState(leads);

    // Handle the filters dropdown opening
    const handleFiltersDropdown = () => {
        setOpenLeadsFilters(!openLeadsFilters);
    };

    // Handle the Type of Requirement dropdown toggle
    const handleTypeOfRfqDropdown = () => {
        setOpentypeOfRfq(!opentypeOfRfq);
        setOpenStatus(false);
        setOpenDateRange(false);
    };

    // Handle the Status dropdown toggle
    const handleStatusDropdown = () => {
        setOpenStatus(!openStatus);
        setOpentypeOfRfq(false);
        setOpenDateRange(false);
    };

    // Handle the Date Range dropdown toggle
    const handleDateRangeDropdown = () => {
        setOpenDateRange(!openDateRange);
        setOpenStatus(false);
        setOpentypeOfRfq(false);
    };

    // Add filter to selectedFilters
    const handleSelectFilter = (type, value) => {
        setSelectedFilters((prevFilters) => [
            ...prevFilters,
            { type, value }
        ]);
    };

    // Remove filter from selectedFilters
    const handleRemoveFilter = (filterToRemove) => {
        setSelectedFilters((prevFilters) =>
            prevFilters.filter((filter) => filter !== filterToRemove)
        );
    };

    // Date Range filters
    const handleFilterDataLastSevenDays = () => {
        const today = new Date();
        const sevenDaysAgo = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000);
        const filteredArray = newLeadsFixedData?.filter((obj) => {
            const objDate = new Date(obj.createDate);
            return objDate >= sevenDaysAgo;
        });
        setNewLeads(filteredArray);
        handleSelectFilter("Date Range", "Last 7 days");
    };

    const handleFilterDataLastMonths = () => {
        const today = new Date();
        const thirtyDaysAgo = new Date(today.getTime() - 30 * 24 * 60 * 60 * 1000);
        const filteredArray = newLeadsFixedData?.filter((obj) => {
            const objDate = new Date(obj.createDate);
            return objDate >= thirtyDaysAgo;
        });
        setNewLeads(filteredArray);
        handleSelectFilter("Date Range", "Last 30 days");
    };

    const handleFilterDataAllDays = () => {
        setNewLeads(newLeadsFixedData);
        handleSelectFilter("Date Range", "All Requirements");
    };

    // Handle Type of Requirement selection
    const handleSelectTypeOfRfq = (value) => {
        handleSelectFilter(value);
    };

    // Handle Status selection
    const handleSelectStatus = (value) => {
        handleSelectFilter(value);
    };

    return (
        <div className="text-[10px]">
            <button
                onClick={handleFiltersDropdown}
                className="flex bg-white border shadow-md items-center gap-2 mx-4 my-4 border-gray-300 p-2 text-sm relative"
            >
                <img
                    src="https://storagereponeevaydevcdn.blob.core.windows.net/business/leadsFilters_leads.svg"
                    alt=""
                />
                Filters
            </button>

            {/* Show selected filters as chips */}
            {selectedFilters.length > 0 && (
                <div className="flex gap-2 mx-4 mt-2">
                    {selectedFilters.map((filter, index) => (
                        <div
                            key={index}
                            className="flex items-center gap-1 bg-gray-200 px-2 py-1 rounded-full text-xs text-black"
                        >
                            <span>{`${filter.value}`}</span>
                            <button
                                onClick={() => handleRemoveFilter(filter)}
                                className="text-sm cursor-pointer"
                            >
                                &times;
                            </button>
                        </div>
                    ))}
                </div>
            )}

            {openLeadsFilters && (
                <ul className="w-fit py-1 shadow-lg border mx-4 absolute bg-white">
                    <li
                        onClick={handleTypeOfRfqDropdown}
                        className="relative flex justify-between cursor-pointer w-full text-start items-center py-2 gap-2 hover:bg-gray-200 px-3"
                    >
                        <div className="flex items-center gap-2 whitespace-nowrap">
                            <img
                                src="https://storagereponeevaydevcdn.blob.core.windows.net/business/type_of_rfq_leads.svg"
                                alt=""
                            />
                            Type of Requirement
                        </div>
                        <img
                            src="https://storagereponeevaydevcdn.blob.core.windows.net/business/filters_arrow_leads.svg"
                            alt=""
                            className={`${opentypeOfRfq ? 'rotate-180 duration-100' : ''}`}
                        />
                    </li>

                    {opentypeOfRfq && (
                        <ul className="z-20 absolute py-1 top-0 w-32 ml-[154px] shadow-md border bg-white">
                            <li
                                className="p-2 hover:bg-gray-200"
                                onClick={() => handleSelectTypeOfRfq("Material")}
                            >
                                <label>
                                    <input type="checkbox" className="mr-2 focus:ring-0 w-3 h-3" />
                                    Material
                                </label>
                            </li>
                            <li
                                className="p-2 hover:bg-gray-200"
                                onClick={() => handleSelectTypeOfRfq("Labour")}
                            >
                                <label>
                                    <input type="checkbox" className="mr-2 focus:ring-0 w-3 h-3" />
                                    Labour
                                </label>
                            </li>
                            <li
                                className="p-2 hover:bg-gray-200"
                                onClick={() => handleSelectTypeOfRfq("Contractor")}
                            >
                                <label>
                                    <input type="checkbox" className="mr-2 focus:ring-0 w-3 h-3" />
                                    Contractor
                                </label>
                            </li>
                        </ul>
                    )}

                    <li
                        onClick={handleDateRangeDropdown}
                        className="flex justify-between relative cursor-pointer w-full text-start items-center py-2 gap-2 hover:bg-gray-200 px-3"
                    >
                        <div className="flex items-center gap-2 whitespace-nowrap">
                            <img
                                src="https://storagereponeevaydevcdn.blob.core.windows.net/business/date_range_leads.svg"
                                alt=""
                            />
                            Date Range
                        </div>
                        <img
                            src="https://storagereponeevaydevcdn.blob.core.windows.net/business/filters_arrow_leads.svg"
                            alt=""
                            className={`${openDateRange ? 'rotate-180 duration-100' : ''}`}
                        />
                    </li>

                    {openDateRange && (
                        <ul className="z-20 absolute py-1 top-9 w-32 ml-[154px] shadow-md border bg-white">
                            <li
                                className="p-2 hover:bg-gray-200"
                                onClick={handleFilterDataLastSevenDays}
                            >
                                <label>
                                    <input
                                        type="radio"
                                        name="timePeriod"
                                        className="mr-2 focus:ring-0 w-3 h-3 rounded-sm"
                                    />
                                    Last 7 days
                                </label>
                            </li>
                            <li
                                className="p-2 hover:bg-gray-200"
                                onClick={handleFilterDataLastMonths}
                            >
                                <label>
                                    <input
                                        type="radio"
                                        name="timePeriod"
                                        className="mr-2 focus:ring-0 w-3 h-3 rounded-sm"
                                    />
                                    Last 30 days
                                </label>
                            </li>
                            <li
                                className="p-2 hover:bg-gray-200"
                                onClick={handleFilterDataAllDays}
                            >
                                <label>
                                    <input
                                        type="radio"
                                        name="timePeriod"
                                        className="mr-2 focus:ring-0 w-3 h-3 rounded-sm"
                                    />
                                    All Requirements
                                </label>
                            </li>
                        </ul>
                    )}

                    <li
                        onClick={handleStatusDropdown}
                        className="flex justify-between relative cursor-pointer w-full text-start items-center py-2 gap-2 hover:bg-gray-200 px-3"
                    >
                        <div className="flex items-center gap-2 whitespace-nowrap">
                            <img
                                src="https://storagereponeevaydevcdn.blob.core.windows.net/business/status.svg"
                                alt=""
                            />
                            Status
                        </div>
                        <img
                            src="https://storagereponeevaydevcdn.blob.core.windows.net/business/filters_arrow_leads.svg"
                            alt=""
                            className={`${openStatus ? 'rotate-180 duration-100' : ''}`}
                        />
                    </li>

                    {openStatus && (
                        <ul className="z-20 absolute py-1 top-16 w-36 ml-[154px] shadow-md border bg-white">
                            <li
                                className="p-2 hover:bg-gray-200"
                                onClick={() => handleSelectStatus("Open Requirement")}
                            >
                                <label>
                                    <input
                                        type="checkbox"
                                        className="mr-2 focus:ring-0 w-3 h-3 rounded-sm"
                                    />
                                    Open Requirement
                                </label>
                            </li>
                            <li
                                className="p-2 hover:bg-gray-200"
                                onClick={() => handleSelectStatus("Quotation Submitted")}
                            >
                                <label>
                                    <input
                                        type="checkbox"
                                        className="mr-2 focus:ring-0 w-3 h-3 rounded-sm"
                                    />
                                    Quotation Submitted
                                </label>
                            </li>
                            <li
                                className="p-2 hover:bg-gray-200"
                                onClick={() => handleSelectStatus("Negotiation")}
                            >
                                <label>
                                    <input
                                        type="checkbox"
                                        className="mr-2 focus:ring-0 w-3 h-3 rounded-sm"
                                    />
                                    Negotiation
                                </label>
                            </li>
                            <li
                                className="p-2 hover:bg-gray-200"
                                onClick={() => handleSelectStatus("Lost")}
                            >
                                <label>
                                    <input
                                        type="checkbox"
                                        className="mr-2 focus:ring-0 w-3 h-3 rounded-sm"
                                    />
                                    Lost
                                </label>
                            </li>
                            <li
                                className="p-2 hover:bg-gray-200"
                                onClick={() => handleSelectStatus("Won")}
                            >
                                <label>
                                    <input
                                        type="checkbox"
                                        className="mr-2 focus:ring-0 w-3 h-3 rounded-sm"
                                    />
                                    Won
                                </label>
                            </li>
                        </ul>
                    )}
                </ul>
            )}
        </div>
    );
};

export default LeadsFilters;
